import * as React from 'react';

export type FacetProps = {
  id: string;
  name: string;
  count: number;
};

export type FacetCategoryProps = {
  name: string;
  label: string;
  tags: FacetProps[];
};

export type SelectedFacetsProps = {
  [category: string]: string[];
};

export type SearchStateProps = {
  query?: string;
  page: number;
  sort: string;
  facets: FacetCategoryProps[];
  selectedFacets: SelectedFacetsProps;
  results: any[];
  resultsTotal: number;
  loading: boolean;
};

type SearchContextProps = {
  state: SearchStateProps;
  updateQuery: (query: string) => void;
  updatePage: (page: number) => void;
  updateSort: (sort: string) => void;
  addFacet: (category: string, facet: string) => void;
  removeFacet: (category: string, facet: string) => void;
  clearFacets: () => void;
};

type SearchActionType =
  | 'UPDATE_PARAMS'
  | 'UPDATE_QUERY'
  | 'UPDATE_PAGE'
  | 'UPDATE_SORT'
  | 'ADD_FACET'
  | 'REMOVE_FACET'
  | 'CLEAR_FACETS'
  | 'SET_DATA';

type SearchAction = { type: SearchActionType; payload?: any };

export const searchReducer = (
  state: SearchStateProps,
  action: SearchAction
) => {
  let selectedfacetClone: SelectedFacetsProps;
  let category: string[];

  switch (action.type) {
    case 'UPDATE_PARAMS':
      return {
        ...state,
        ...action.payload
      };
    case 'UPDATE_QUERY':
      return {
        ...state,
        query: action.payload,
        page: 1
      };
    case 'UPDATE_PAGE':
      return {
        ...state,
        page: action.payload
      };
    case 'UPDATE_SORT':
      return {
        ...state,
        sort: action.payload,
        page: 1
      };
    case 'ADD_FACET':
      selectedfacetClone = JSON.parse(JSON.stringify(state.selectedFacets));
      category = selectedfacetClone[action.payload.category] || [];
      selectedfacetClone[action.payload.category] = [
        ...category,
        action.payload.facet
      ];

      return {
        ...state,
        selectedFacets: selectedfacetClone,
        page: 1
      };
    case 'REMOVE_FACET':
      selectedfacetClone = JSON.parse(JSON.stringify(state.selectedFacets));

      selectedfacetClone[action.payload.category].splice(
        selectedfacetClone[action.payload.category].indexOf(
          action.payload.facet
        ),
        1
      );

      if (!selectedfacetClone[action.payload.category].length) {
        delete selectedfacetClone[action.payload.category];
      }

      return {
        ...state,
        selectedFacets: selectedfacetClone,
        page: 1
      };
    case 'CLEAR_FACETS':
      return {
        ...state,
        selectedFacets: {},
        page: 1
      };
    case 'SET_DATA':
      return {
        ...state,
        results: action.payload.results,
        resultsTotal: action.payload.resultsTotal,
        facets: action.payload.facets
      };
    default:
      return state;
  }
};

export const SearchContext = React.createContext<SearchContextProps>({
  state: {
    page: 1,
    sort: 'relevance',
    facets: [],
    selectedFacets: {},
    results: [],
    resultsTotal: 0,
    loading: false
  },
  updateQuery: () => undefined,
  updatePage: () => undefined,
  updateSort: () => undefined,
  addFacet: () => undefined,
  removeFacet: () => undefined,
  clearFacets: () => undefined
});
